import WalletAddress from './WalletAddress';

export default WalletAddress;
